import { render, staticRenderFns } from "./ProgramBuildingLots.vue?vue&type=template&id=221b85c6&"
import script from "./ProgramBuildingLots.vue?vue&type=script&lang=js&"
export * from "./ProgramBuildingLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports